import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["SearchBarWithNoToggle"] */ "/opt/atlassian/pipelines/agent/build/src/components/SearchBar/SearchBar.tsx");
